import { Map } from 'immutable';
import isNil from 'lodash/isNil';

// Can be used with one key or a key path, e.g.
// to get a station getFromMap(maybeMap, 'stationId') or to get the name from the station
// getFromMap(maybeMap, 'stationId', 'name');
export function getFromMap<K, V>(map: Map<K, V>, ...keys: K[]): V {
  return Map.isMap(map) ? map.getIn([...keys], null) : null;
}

// This function takes an array of functions and will return the
// first non nil result returned when passing the args into the functions
// from the left
export function returnFirstNonNilResult(
  funcs: $TSFixMeFunction[] = [],
  ...args: $TSFixMe[]
): $TSFixMe {
  let result;
  for (let i = 0; i < funcs.length; i++) {
    result = funcs[i](...args);
    if (!isNil(result)) return result;
  }
  return null;
}

const defaultKeyCalc = (...args: $TSFixMe[]): string => {
  return '' + args[0];
};
export function memoizeCacheSizeOfOne(
  func: $TSFixMe,
  keyCalc: $TSFixMeFunction = defaultKeyCalc,
): $TSFixMe {
  let cache = {};
  return (...args: $TSFixMe[]) => {
    const key = keyCalc(...args);
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (cache[key]) return cache[key];
    // enforce cacheSize of 1
    cache = {};
    // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    return (cache[key] = func(...args));
  };
}

export function tryPromise(fn: $TSFixMe): $TSFixMe {
  if (typeof fn !== 'function') {
    return Promise.reject(new TypeError('fn must be a function'));
  }
  return Promise.resolve().then(fn);
}

// For the rare cases where you want to use Promise.all in the call effect
// in a redux saga
export function promiseAll(promises: $TSFixMe): $TSFixMe {
  return Promise.all(promises);
}
